import ReplaceCard from '../../../../banking/components/cards/replace-card/ReplaceCard';

const ReplaceCardScreen = () => {
    return <ReplaceCard />;
};

export default ReplaceCardScreen;
